/* TVC Patches v15 — simplified Buy Now flow: no cart for international
   Loaded AFTER tvc-app.js. Responsibilities:
   (1) Log every PayPal form submission to Google Sheets.                      [v4]
   (2) Fix PayPal modal for digital products (no ₹2500 shipping addition).     [v4]
   (3) Country allowlist for PayPal: only US, CA, GB, AU, MY, SG, AE.          [v4]
   (4) Minimum order ₹4,000 (skipped for digital products).                    [v4]
   (5) For non-allowlist countries: hide PayPal CTAs.                          [v4]
   (6) For ALL non-IN visitors: hide Shopify dynamic checkout strip.           [v5]
   (7) Rewrite paypal.me/vediccrystals1 → paypal.me/vediccrystals globally.    [v6]
   (8) PayPal Smart Buttons disabled — paypal.me flow only.                    [v6]
   (9) Submit-click detection uses closest() so SVG clicks log Sheets.         [v6]
  (10) Compute correct cart-aware paypal.me amount.                            [v7]
  (11) Rewrite visible modal summary in user's local currency.                 [v8]
  (12) Detect cart.currency and back-convert to INR before applying FX.    [v9]
  (13) Item title truncation increased 60 → 80 chars.                       [v9]
  (14) On product page DOM fallback, detect that theme.liquid's currency
       script has already converted DOM prices to local currency, and back-
       convert to INR before re-applying FX.                                [v10]
  (15) Enforce ₹4,000 minimum order check at modal-opening level.        [v11]
  (16) Hide dynamic-checkout (GPay/ShopPay/etc) via injected CSS with
       !important so it survives cart-drawer re-renders. Adds Dawn web
       component selectors. Also scans descendants of added nodes in
       MutationObserver instead of just the top-level node.              [v12]
  (17) Expanded selector list (Razorpay, SellAbroad, generic [data-shopify^=
       "dynamic-checkout"] wrapper); position:absolute -9999px belt-and-
       suspenders; runtime DOM scan finds containers with G Pay/Google Pay/
       Shop Pay text content and hides them. Catches third-party gateway
       buttons that don't use Shopify's standard selectors.              [v13]
  (18) Blocked-country check at modal-opening level + capture-phase click
       intercept on cart-drawer Checkout. Closes the gap where tvc-app.js
       opens the PayPal modal for non-allowlisted countries (e.g. Mauritius
       MU). The product-page .tvc-paypal-btn already checked allowlist; this
       extends that protection to every modal-opening path.              [v14]
  (19) Simplified international flow: for non-IN visitors, hide the cart
       drawer, cart icon, /cart links, and Add-to-Cart button. The
       .tvc-paypal-btn ("Buy Now") becomes the sole CTA on product pages,
       styled prominently. For blocked countries, product form buttons are
       hidden entirely and a WhatsApp banner is inserted above the product
       form. India visitors are unaffected — all rules are body-class-scoped
       (tvc-non-india / tvc-allowlisted / tvc-blocked). Prior v14 protections
       remain as safety nets in case any cart path re-emerges.           [v15]
  (20) v16: Razorpay + native Shopify checkout re-enabled alongside PayPal.
       Allowlisted countries can now use Add to Cart → Cart → Checkout →
       Razorpay (cards/UPI/netbanking/wallets in local currency) as the
       primary path, OR the existing "Buy Now with PayPal" modal as an
       alternative. Changes: (a) Razorpay selectors removed from the
       aggressive hide list; (b) cart drawer / cart icon / cart page hiding
       scoped to blocked countries only (not all non-IN); (c) Add-to-Cart
       button un-hidden for allowlisted; (d) PayPal Smart Buttons re-enabled
       (enabled:true) so the modal shows real PayPal buttons + paypal.me
       fallback. GPay/Shop Pay/Apple Pay still hidden — Razorpay handles
       cards natively and the accelerated branded buttons look ugly.
       Blocked-country behaviour is unchanged: prices in local currency,
       WhatsApp banner, no checkout possible.                             [v16]
  (21) v16.1: Enforce ₹4,000 min order on the NATIVE Shopify Checkout path
       (Razorpay), not just the PayPal modal. Without this, an allowlisted
       international customer could Add to Cart a ₹1,000 item → Checkout →
       Razorpay and complete an order below shipping cost. Consolidates
       the old separate blocked-country intercept with the new min-order
       check into ONE async capture-phase intercept: (a) sync blocked-
       country check fires first (immediate alert, no wait); (b) async
       cart.js fetch computes INR-equivalent total using the same
       nativeToInr() helper as the PayPal path; (c) if physical items and
       total < ₹4,000, min-order alert shown; (d) if pass, __tvcCheckoutPassed
       flag set and re-click dispatched. Defense-in-depth: if async fetch
       fails, request passes through with server-side backstop expected
       (Shopify shipping rate floor recommended as backup).            [v16.1]
*/
(function(){
  var SHEETS_URL = "https://script.google.com/macros/s/AKfycbxK461k_hfW3PhjcK800Bb75YZk3bw5eOKp4kd4Da9mIB5dh-4T7z5GPrTmgj2bryE/exec";
  var ALLOWED_COUNTRIES = ["US","CA","GB","AU","MY","SG","AE"];
  var MIN_ORDER_INR = 4000;
  var SHIPPING_INR = 2500;
  var TITLE_MAX = 80; // v9: bumped from 60
  var PAYPAL_ME_SUPPORTED = ["USD","AUD","BRL","CAD","CZK","DKK","EUR","GBP","HKD","HUF","ILS","JPY","MXN","MYR","NZD","NOK","PHP","PLN","SGD","SEK","CHF","TWD","THB"];
  var INR_USD_FALLBACK = 0.0118;
  var SYM = {USD:"$",GBP:"£",EUR:"€",AUD:"A$",CAD:"CA$",SGD:"S$",NZD:"NZ$",JPY:"¥",CHF:"CHF ",MYR:"RM ",AED:"AED ",SAR:"SAR ",HKD:"HK$",SEK:"SEK ",NOK:"NOK ",DKK:"DKK ",PLN:"PLN ",CZK:"Kč ",HUF:"Ft ",ILS:"₪",MXN:"MX$",PHP:"₱",THB:"฿",TWD:"NT$",BRL:"R$",KWD:"KWD ",OMR:"OMR ",QAR:"QAR ",BHD:"BHD "};

  function val(id){ var el = document.getElementById(id); return el ? (el.value || "").trim() : ""; }
  function isNonIndia(){ var c = window.__saGeoCountry; return !!(c && c !== "IN"); }
  function isBlockedCountry(){
    var c = window.__saGeoCountry;
    if (!c) return false;
    if (c === "IN") return false;
    return ALLOWED_COUNTRIES.indexOf(c) === -1;
  }
  function isPaypalMeSupported(ccy){ return PAYPAL_ME_SUPPORTED.indexOf(String(ccy).toUpperCase()) > -1; }
  function fmtAmount(num, ccy){ var sym = SYM[ccy] || (ccy + " "); return sym + Number(num).toFixed(2); }
  function escapeHtml(s){ return String(s || "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); }

  /* ============ rewrite vediccrystals1 → vediccrystals ============ */
  function rewriteNewPaypalUrl(url){
    if (typeof url !== "string") return url;
    if (url.indexOf("paypal.me/vediccrystals") === -1) return url;
    return url.replace(/paypal\.me\/vediccrystals1(?=\/|$)/g, "paypal.me/vediccrystals");
  }
  (function patchWindowOpen(){
    var orig = window.open;
    window.open = function(url, target, features){
      return orig.call(window, rewriteNewPaypalUrl(url), target, features);
    };
  })();

  /* ============ live INR→USD rate (cached 24h) ============ */
  function getInrToUsd(){
    try {
      var cached = localStorage.getItem("tvc_inr_usd_v1");
      if (cached) {
        var parsed = JSON.parse(cached);
        if (parsed && parsed.rate > 0 && parsed.expires > Date.now()) return Promise.resolve(parsed.rate);
      }
    } catch(_) {}
    return fetch("https://api.frankfurter.app/latest?from=INR&to=USD")
      .then(function(r){ return r.json(); })
      .then(function(j){
        var rate = j && j.rates && j.rates.USD;
        if (rate && rate > 0) {
          try { localStorage.setItem("tvc_inr_usd_v1", JSON.stringify({ rate: rate, expires: Date.now() + 86400000 })); } catch(_) {}
          return rate;
        }
        return INR_USD_FALLBACK;
      })
      .catch(function(){ return INR_USD_FALLBACK; });
  }

  /* ============ rewrite visible summary in local currency ============ */
  function rewriteSummary(modal, items, totalInr, fx, ccy, isDigital){
    if (!modal || !items || !items.length) return;
    if (!fx || fx <= 0) return;
    var summary = modal.querySelector(".tvc-pp-checkout-summary");
    if (!summary) return;

    function fmt(inr){ return fmtAmount(inr * fx, ccy); }

    var html = "";
    items.forEach(function(item){
      var qtyTxt = item.qty > 1 ? " × " + item.qty : "";
      html += '<div class="tvc-pp-checkout-summary-row"><span>' + escapeHtml(item.title) + escapeHtml(qtyTxt) + '</span><span>' + fmt(item.lineInr) + '</span></div>';
    });
    if (!isDigital) {
      html += '<div class="tvc-pp-checkout-summary-row"><span>International Shipping</span><span>' + fmt(SHIPPING_INR) + '</span></div>';
    }
    html += '<div class="tvc-pp-checkout-summary-row total"><span>Total</span><span>' + fmt(totalInr) + '</span></div>';
    summary.innerHTML = html;
  }

  /* ============ build items + cache URL + rewrite summary ============ */
  function processItems(modal, items, subInr){
    if (!items.length || subInr <= 0) return;
    var isDigital = !!window.__tvcDigitalProduct;
    var totalInr = subInr + (isDigital ? 0 : SHIPPING_INR);
    var fx = window.__saFxLastRate;
    var displayCcy = (window.__saFxTargetCurrency || "USD").toUpperCase();

    try { rewriteSummary(modal, items, totalInr, fx, displayCcy, isDigital); } catch(_) {}

    if (isPaypalMeSupported(displayCcy) && fx && fx > 0) {
      var amt = totalInr * fx;
      modal.dataset.tvcPaypalUrl = "https://www.paypal.me/vediccrystals/" + amt.toFixed(2) + displayCcy;
      modal.dataset.tvcPaypalAmount = fmtAmount(amt, displayCcy);
      return;
    }

    getInrToUsd().then(function(inrToUsd){
      var usdAmt = totalInr * inrToUsd;
      modal.dataset.tvcPaypalUrl = "https://www.paypal.me/vediccrystals/" + usdAmt.toFixed(2) + "USD";
      modal.dataset.tvcPaypalAmount = fmtAmount(usdAmt, "USD");

      if (displayCcy !== "USD") {
        try {
          var summary = modal.querySelector(".tvc-pp-checkout-summary");
          if (summary && !summary.querySelector(".tvc-pp-usd-note")) {
            var note = document.createElement("div");
            note.className = "tvc-pp-usd-note";
            note.style.cssText = "font-size:11px;color:#8E8E93;text-align:center;margin-top:8px;padding-top:8px;border-top:1px solid rgba(0,0,0,0.06);";
            note.textContent = "PayPal will charge $" + usdAmt.toFixed(2) + " USD";
            summary.appendChild(note);
          }
        } catch(_) {}
      }
    }).catch(function(){});
  }

  /* ============ v9: cart-aware reader with currency back-conversion ============ */
  // Convert a "native" line amount (in whatever currency cart.js returns) to INR.
  // If cart.currency === INR, the value IS already INR — pass through.
  // Else (Shopify Markets converted prices to EUR/USD/etc), divide by FX rate
  // to get back to INR equivalent.
  function nativeToInr(nativeAmount, cartCurrency, fx){
    if (!nativeAmount || nativeAmount <= 0) return 0;
    if (cartCurrency === "INR") return nativeAmount;
    if (fx && fx > 0) return nativeAmount / fx;
    return nativeAmount; // fallback — better than nothing
  }

  function computeAndCachePaypalUrl(modal){
    if (!modal || modal.dataset.tvcPaypalUrlComputed === "1") return;
    modal.dataset.tvcPaypalUrlComputed = "1";

    // v9: always fetch /cart.js first to know cart.currency, then decide
    // whether to use cart items or fall back to product page DOM.
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var cartCurrency = ((cart && cart.currency) || "INR").toUpperCase();
        var fx = window.__saFxLastRate;
        var isProductPage = window.location.pathname.indexOf("/products/") > -1;

        var items = [];
        var subInr = 0;

        if (cart && cart.items && cart.items.length) {
          // Use cart items
          cart.items.forEach(function(item){
            var qty = item.quantity || 1;
            var lineNative = (item.final_line_price || item.line_price || (item.price * qty)) / 100;
            var lineInr = nativeToInr(lineNative, cartCurrency, fx);
            items.push({
              title: (item.product_title || item.title || "Item").substring(0, TITLE_MAX),
              qty: qty,
              lineInr: lineInr
            });
            subInr += lineInr;
          });
        } else if (isProductPage) {
          // Empty cart on product page — read product price from DOM.
          // v10: theme.liquid currency conversion script mutates these same DOM
          // elements from INR → local currency. If geo says non-IN AND we have
          // an FX rate, the DOM text is already in local currency, so we
          // back-convert to INR before further processing.
          var priceEl = document.querySelector('[data-product-price], .price__regular .price-item--regular, .price .money, .price-item--sale');
          var titleEl = document.querySelector('.product__title, .product-title, h1.title, h1');
          if (!priceEl) return;
          var txt = priceEl.textContent.replace(/[^\d.,]/g, "").replace(/,/g, "");
          var unitNative = parseFloat(txt) || 0;
          if (unitNative <= 0) return;
          var domIsLocalCurrency = !!(window.__saGeoCountry && window.__saGeoCountry !== "IN" && fx && fx > 0 && fx !== 1);
          var unitInr = domIsLocalCurrency ? (unitNative / fx) : unitNative;
          items.push({
            title: (titleEl ? titleEl.textContent.trim() : "Product").substring(0, TITLE_MAX),
            qty: 1,
            lineInr: unitInr
          });
          subInr = unitInr;
        }

        if (subInr <= 0) return;

        // v14: Blocked-country check at modal level. Same gap pattern as v11:
        // tvc-app.js intercepts the cart-drawer/cart-page Checkout click and
        // opens the modal directly, so the .tvc-paypal-btn click handler that
        // already checks isBlockedCountry() never fires. Without this check,
        // a non-allowlisted country (e.g. Mauritius MU) reaches the PayPal
        // flow via cart drawer Checkout. This closes the modal and shows the
        // blocked-country alert before any paypal URL is computed.
        if (isBlockedCountry()) {
          try {
            modal.classList.remove('active');
            document.body.style.overflow = '';
          } catch(_) {}
          showBlockedCountryAlert();
          return;
        }

        // v11: Enforce minimum order at modal level. Catches the cart-drawer
        // / cart-page Checkout flow where tvc-app.js intercepts the click and
        // opens the modal directly, bypassing the .tvc-paypal-btn min-order
        // check. Skip for digital products (which have no shipping & no min).
        var isDigital = !!window.__tvcDigitalProduct;
        if (!isDigital && subInr < MIN_ORDER_INR) {
          try {
            modal.classList.remove('active');
            document.body.style.overflow = '';
          } catch(_) {}
          showMinOrderAlert();
          return;
        }

        processItems(modal, items, subInr);
      })
      .catch(function(){ });
  }

  function bestPaypalUrl(url, modal){
    if (modal && modal.dataset.tvcPaypalUrl) return modal.dataset.tvcPaypalUrl;
    return rewriteNewPaypalUrl(url);
  }

  /* ============ digital product helpers (v4) ============ */
  function getProductPriceNumber(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return 0;
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return 0;
    return parseFloat((spans[1].textContent || "0").replace(/[^\d.]/g, "")) || 0;
  }
  function getProductPriceText(){
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    if (!rows.length) return "";
    var spans = rows[0].querySelectorAll("span");
    if (spans.length !== 2) return "";
    return (spans[1].textContent || "").trim();
  }
  function rewritePaypalUrlDigital(url){
    if (typeof url !== "string" || url.indexOf("paypal.me/vediccrystals") === -1) return url;
    var m = url.match(/(.+\/)([0-9.]+)([A-Z]+)$/);
    if (!m) return url;
    var price = getProductPriceNumber();
    if (price <= 0) return url;
    return m[1] + price.toFixed(2) + m[3];
  }
  function readSummary(){
    var data = { product:"", variant:"", price:"", shipping:"", total:"" };
    var rows = document.querySelectorAll(".tvc-pp-checkout-summary-row");
    for (var i = 0; i < rows.length; i++) {
      var spans = rows[i].querySelectorAll("span");
      if (spans.length !== 2) continue;
      var lbl = (spans[0].textContent || "").trim();
      var v   = (spans[1].textContent || "").trim();
      if (i === 0) { data.product = lbl; data.price = v; }
      else if (lbl.indexOf("Variant:") === 0) data.variant = lbl.replace(/^Variant:\s*/, "");
      else if (lbl.indexOf("International Shipping") === 0) data.shipping = v;
      else if (lbl === "Total") data.total = v;
    }
    return data;
  }

  function fixPostSubmitUrls(modal){
    if (!modal) return;
    var correctUrl = modal.dataset.tvcPaypalUrl || "";
    var correctAmount = modal.dataset.tvcPaypalAmount || "";

    var links = modal.querySelectorAll('a[href*="paypal.me"]');
    for (var i = 0; i < links.length; i++) {
      var oldHref = links[i].getAttribute("href");
      var newHref;
      if (correctUrl) newHref = correctUrl;
      else if (window.__tvcDigitalProduct) newHref = rewritePaypalUrlDigital(rewriteNewPaypalUrl(oldHref));
      else newHref = rewriteNewPaypalUrl(oldHref);
      links[i].setAttribute("href", newHref);

      var label = correctAmount || (window.__tvcDigitalProduct ? getProductPriceText() : "");
      if (label) {
        for (var j = 0; j < links[i].childNodes.length; j++) {
          var node = links[i].childNodes[j];
          if (node.nodeType === 3 && /Pay\s+\S+\s+Now/.test(node.nodeValue)) {
            node.nodeValue = node.nodeValue.replace(/Pay\s+\S+\s+Now/, "Pay " + label + " Now");
          }
        }
      }
    }

    var divs = modal.querySelectorAll("div");
    for (var k = 0; k < divs.length; k++) {
      if (divs[k].children.length === 0) {
        var txt = (divs[k].textContent || "").trim();
        if (/^https?:\/\/.+paypal\.me\/vediccrystals1?\/[0-9.]+[A-Z]+$/.test(txt)) {
          var newTxt;
          if (correctUrl) newTxt = correctUrl;
          else if (window.__tvcDigitalProduct) newTxt = rewritePaypalUrlDigital(rewriteNewPaypalUrl(txt));
          else newTxt = rewriteNewPaypalUrl(txt);
          divs[k].textContent = newTxt;
        }
      }
    }

    var hdrLabel = correctAmount || (window.__tvcDigitalProduct ? getProductPriceText() : "");
    if (hdrLabel) {
      var headers = modal.querySelectorAll('div[style*="font-weight:700"]');
      for (var h = 0; h < headers.length; h++) {
        var ht = headers[h].textContent || "";
        if (/^Pay\s+\S+\s+via\s+PayPal/i.test(ht.trim())) {
          headers[h].textContent = ht.replace(/^Pay\s+\S+\s+via/i, "Pay " + hdrLabel + " via");
        }
      }
    }
  }

  function hideDynamicCheckout(){
    if (!isNonIndia()) return;
    var sel = ".shopify-payment-button, [data-shopify-buttoncontainer], .dynamic-checkout, .dynamic-checkout__content, .additional-checkout-buttons";
    var els = document.querySelectorAll(sel);
    for (var i = 0; i < els.length; i++) els[i].style.display = "none";
  }
  function hidePaypalElements(){
    hideDynamicCheckout();
    injectHideDynamicCheckoutCSS();
    aggressiveHideAcceleratedCheckout();  // v13: runtime DOM scan
    applySimplifiedFlow();                 // v15: Buy Now flow + banner
    if (!isBlockedCountry()) return;
    var els = document.querySelectorAll(".tvc-paypal-wrap, .tvc-shipping-notice, .tvc-intl-banner");
    for (var i = 0; i < els.length; i++) els[i].style.display = "none";
  }

  // v12/v13: Inject CSS with !important to hide dynamic checkout
  // (Shopify GPay/ShopPay AND third-party Razorpay accelerated checkout).
  // CSS persists across cart drawer re-renders, unlike inline style.display.
  // v16: Razorpay selectors REMOVED from hide list — Razorpay is now allowed
  // as an alternative payment path via Shopify's native checkout flow.
  // GPay/Shop Pay/Apple Pay remain hidden (Razorpay handles cards, and the
  // branded accelerated buttons clutter the product page).
  function injectHideDynamicCheckoutCSS(){
    if (!isNonIndia()) return;
    if (document.getElementById('tvc-hide-dyn-checkout-css')) return;
    var s = document.createElement('style');
    s.id = 'tvc-hide-dyn-checkout-css';
    s.textContent = [
      // ── Shopify standard (GPay/ShopPay/ApplePay) ──
      '.shopify-payment-button',
      '.shopify-payment-button__button',
      '.shopify-payment-button__more-options',
      '[data-shopify-buttoncontainer]',
      '[data-shopify="dynamic-checkout"]',
      '[data-shopify="dynamic-checkout-cart"]',
      '[data-shopify^="dynamic-checkout"]',
      '[data-shopify="payment-button"]',
      '.dynamic-checkout',
      '.dynamic-checkout__content',
      '.dynamic-checkout__button',
      '.dynamic-checkout-buttons',
      '.additional-checkout-buttons',
      '.additional-checkout-button',
      'shopify-accelerated-checkout',
      'shopify-accelerated-checkout-cart',
      'shopify-accelerated-checkout-button',
      'shopify-payment-terms',
      'wallet-button-list',
      // ── SellAbroad / generic accelerated checkout app blocks ──
      '[data-block-type*="payment"]',
      '[data-block-type*="checkout"]',
      '[data-app-block*="payment"]',
      '[data-app-block*="checkout"]',
      // ── Generic — match by class/id substring ──
      '[id*="accelerated-checkout"]',
      '[class*="accelerated-checkout"]'
    ].join(',') + '{display:none !important;visibility:hidden !important;height:0 !important;width:0 !important;overflow:hidden !important;pointer-events:none !important;position:absolute !important;left:-9999px !important;}';
    (document.head || document.documentElement).appendChild(s);
  }

  // v13: Runtime DOM scan to catch ANY container with G Pay / Google Pay /
  // Shop Pay / Apple Pay branding that we missed via selectors. Limited to
  // inside known wrapper containers so we never hide unrelated elements.
  // Note: this regex intentionally does NOT match "Pay with Razorpay" — v16
  // keeps Razorpay visible as an alternative payment path.
  function aggressiveHideAcceleratedCheckout(){
    if (!isNonIndia()) return;
    var wrappers = document.querySelectorAll(
      '.product-form__buttons, .cart__ctas-container, .cart-drawer__footer, .drawer__footer, .product-form, main, [data-section-type*="product"]'
    );
    var skipCls = /(tvc-paypal-wrap|tvc-paypal-btn|tvc-pp-checkout|tvc-shipping-notice|tvc-intl-banner|product-form__submit|cart__checkout-button|cart__update-button|drawer__close|view_cart|quantity__|quantity-input)/;
    for (var w = 0; w < wrappers.length; w++) {
      var nodes = wrappers[w].querySelectorAll('*');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (!el.className || typeof el.className !== 'string') continue;
        if (skipCls.test(el.className)) continue;
        // Look for inline text that screams accelerated checkout
        var text = (el.textContent || '').trim();
        if (text.length === 0 || text.length > 80) continue;
        if (/^(G\s*Pay|Google\s*Pay|Apple\s*Pay|Shop\s*Pay|Buy\s+(it\s+)?now\s+with|Pay\s+with\s+(Google|Apple|Shop))/i.test(text)) {
          el.style.display = 'none';
          // walk up to ~3 ancestors and hide them if they contain only this element
          var p = el.parentElement;
          for (var d = 0; d < 3 && p; d++) {
            if (p.children.length <= 2 && !skipCls.test(p.className || '')) {
              p.style.display = 'none';
              p = p.parentElement;
            } else break;
          }
        }
      }
    }
  }

  function showMinOrderAlert(){
    var fx = window.__saFxLastRate || 1;
    var min = Math.ceil(MIN_ORDER_INR * fx);
    var cur = window.__saFxTargetCurrency || "INR";
    var sym = SYM[cur] || (cur + " ");
    alert("Minimum order for international shipping is " + sym + min.toLocaleString() + " . For orders under this amount, please WhatsApp us at +91 9811 809 967.");
  }

  // v14: Friendly alert shown when a non-allowlisted country tries to check
  // out. The allowlist (ALLOWED_COUNTRIES) covers countries we have shipping
  // costed for; everywhere else is redirected to WhatsApp for custom shipping.
  function showBlockedCountryAlert(){
    var c = window.__saGeoCountry || "your country";
    alert("Sorry, we do not currently ship to " + c + " via online checkout. Please WhatsApp us at +91 9811 809 967 — we can arrange custom shipping and accept a direct PayPal payment.");
  }

  // ============ v15/v16: SIMPLIFIED FLOW =====================
  // v16 update: Only BLOCKED countries lose cart access. Allowlisted countries
  // now retain full cart + Shopify checkout + Razorpay path, AND still see the
  // "Buy Now with PayPal" secondary CTA. India (IN) is unchanged.
  //
  // Blocked non-IN visitors: cart/checkout hidden, product form hidden, WhatsApp
  // banner shown on product pages.
  // Allowlisted non-IN visitors: everything visible — Add to Cart, cart drawer,
  // Checkout, "Buy Now with PayPal" secondary CTA.
  // India (IN) visitors: everything unchanged — no rules apply.
  //
  // All rules body-class-scoped so India visitors are never affected.

  function updateBodyClassesForGeo(){
    if (!document.body || !window.__saGeoCountry) return;
    var c = window.__saGeoCountry;
    var nonIN = (c !== "IN");
    var blocked = nonIN && ALLOWED_COUNTRIES.indexOf(c) === -1;
    document.body.classList.toggle("tvc-non-india", nonIN);
    document.body.classList.toggle("tvc-allowlisted", nonIN && !blocked);
    document.body.classList.toggle("tvc-blocked", blocked);
  }

  function injectSimplifiedFlowCSS(){
    if (!isNonIndia()) return;
    if (document.getElementById("tvc-simplified-flow-css")) return;
    var s = document.createElement("style");
    s.id = "tvc-simplified-flow-css";
    s.textContent =
      // v16: Hide cart UI ONLY for BLOCKED countries — allowlisted uses
      // cart → Checkout → Razorpay as primary flow.
      "body.tvc-blocked cart-drawer," +
      "body.tvc-blocked .cart-drawer," +
      "body.tvc-blocked cart-notification," +
      "body.tvc-blocked .cart-notification," +
      "body.tvc-blocked .header__icon--cart," +
      "body.tvc-blocked a[href=\"/cart\"]," +
      "body.tvc-blocked a[href^=\"/cart?\"]," +
      "body.tvc-blocked .cart-count-bubble," +
      "body.tvc-blocked .header__icon[href*=\"/cart\"]," +
      "body.tvc-blocked.template-cart main," +
      "body.tvc-blocked.template-cart #MainContent" +
      "{display:none !important;visibility:hidden !important;}" +
      // For blocked, hide entire product form (banner replaces it)
      "body.tvc-blocked .product-form__buttons," +
      "body.tvc-blocked .product-form form" +
      "{display:none !important;}" +
      // v16: Style "Buy Now with PayPal" as a full-width SECONDARY CTA for
      // allowlisted — Add to Cart / Checkout remain the primary path.
      "body.tvc-allowlisted .tvc-paypal-wrap" +
      "{margin-top:14px !important;}" +
      "body.tvc-allowlisted .tvc-paypal-btn" +
      "{width:100% !important;max-width:100% !important;margin-top:8px !important;}";
    (document.head || document.documentElement).appendChild(s);
  }

  function showBlockedCountryBanner(){
    if (!isBlockedCountry()) return;
    if (document.getElementById("tvc-blocked-banner")) return;
    if (!/\/products\//.test(window.location.pathname)) return;
    var container = document.querySelector(".product-form, .product__form, .product-info, .product__info-wrapper");
    if (!container) return;
    var c = window.__saGeoCountry || "your region";
    var banner = document.createElement("div");
    banner.id = "tvc-blocked-banner";
    banner.style.cssText = "padding:20px;background:linear-gradient(135deg,#fff8e8,#fdf8eb);border:1px solid #d4a437;border-radius:12px;margin:16px 0;text-align:center;font-family:Georgia,serif;";
    banner.innerHTML =
      '<div style="font-style:italic;color:#3d2459;font-size:16px;line-height:1.5;margin-bottom:12px;">' +
      'We currently ship online to select international regions. For orders from <strong>' + c + '</strong>, please contact us for custom shipping and PayPal payment:' +
      '</div>' +
      '<a href="https://wa.me/919811809967?text=Hi%2C%20I%20am%20interested%20in%20ordering%20from%20your%20store" target="_blank" rel="noopener" style="display:inline-block;background:#25d366;color:#fff;padding:12px 24px;border-radius:10px;text-decoration:none;font-weight:600;font-family:system-ui,-apple-system,sans-serif;">💬 WhatsApp Us at +91 98118 09967</a>';
    container.parentNode.insertBefore(banner, container);
  }

  function applySimplifiedFlow(){
    updateBodyClassesForGeo();
    injectSimplifiedFlowCSS();
    showBlockedCountryBanner();
  }

  var geoWaitCount = 0;
  var geoInterval = setInterval(function(){
    geoWaitCount++;
    if (window.__saGeoCountry) { clearInterval(geoInterval); hidePaypalElements(); }
    if (geoWaitCount > 60) clearInterval(geoInterval);
  }, 250);

  // v16: This intercept still blocks clicks on GPay/Shop Pay/Apple Pay
  // dynamic-checkout branded buttons. Primary Checkout button (button[name=
  // "checkout"], .cart__checkout-button, #CartDrawer-Checkout) is NOT in this
  // selector list — those clicks pass through to native Shopify checkout,
  // which lands the customer on the Razorpay-powered payment page.
  window.addEventListener("click", function(e){
    if (!isNonIndia()) return;
    var sel = '.shopify-payment-button, .shopify-payment-button button, .shopify-payment-button__button, [data-shopify-buttoncontainer], [data-shopify-buttoncontainer] button, .dynamic-checkout, .dynamic-checkout__button, .dynamic-checkout__content, .additional-checkout-buttons, .additional-checkout-buttons button';
    if (e.target.closest(sel)) { e.preventDefault(); e.stopPropagation(); }
  }, true);

  // v16.1: Consolidated Checkout-button intercept — enforces BOTH the blocked-
  // country check AND the ₹4,000 min-order check on the native Shopify Checkout
  // path (Razorpay). Fires for every non-IN visitor. Sync blocked-country check
  // happens first (immediate alert). Allowlisted visitors go through async
  // cart.js fetch → INR-equivalent min-order check → pass or block.
  //
  // Replaces the v14 standalone blocked-country intercept. Merging both checks
  // into ONE intercept avoids double-alerts and gives deterministic ordering.
  //
  // Defense-in-depth: even blocked countries are subjected to this intercept
  // (the sync path handles them). If for any reason the blocked-country check
  // is bypassed (wrong country code, allowlist misconfig), the async min-order
  // check still fires.
  //
  // Flag-based re-click pattern (matches the existing .tvc-paypal-btn handler):
  // when async checks pass, __tvcCheckoutPassed = true and clickedBtn.click()
  // is called. The re-click hits this handler again, sees the flag, returns
  // early, and the click bubbles up to Shopify's native form submit.
  window.addEventListener("click", function(e){
    if (window.__tvcCheckoutPassed) return;
    var country = window.__saGeoCountry;
    if (!country || country === "IN") return;
    var sel = '#CartDrawer-Checkout, .cart__checkout-button, button[name="checkout"], #checkout, [data-cart-checkout]';
    var clickedBtn = e.target.closest && e.target.closest(sel);
    if (!clickedBtn) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    // Sync branch: blocked countries get immediate alert, no fetch needed.
    if (isBlockedCountry()) {
      showBlockedCountryAlert();
      return;
    }

    // Async branch: allowlisted → check min order via cart.js.
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var cartCurrency = ((cart && cart.currency) || "INR").toUpperCase();
        var fx = window.__saFxLastRate;
        var totalNative = (cart && cart.total_price || 0) / 100;
        var totalInr = nativeToInr(totalNative, cartCurrency, fx);
        var anyPhysical = cart && cart.items && cart.items.some(function(i){ return i.requires_shipping !== false; });

        // Defense-in-depth: re-check blocked in case country flipped mid-flight
        if (isBlockedCountry()) { showBlockedCountryAlert(); return; }

        // Min-order check — only enforced when cart has physical items
        // (digital-only carts skip shipping and skip this floor).
        if (anyPhysical && totalInr < MIN_ORDER_INR) {
          showMinOrderAlert();
          return;
        }

        // Passed both checks — allow the click through.
        window.__tvcCheckoutPassed = true;
        try { clickedBtn.click(); } catch(_) {}
        setTimeout(function(){ window.__tvcCheckoutPassed = false; }, 500);
      })
      .catch(function(){
        // Network error on cart.js — fall through to native checkout. Shopify
        // shipping rate floor is the recommended server-side backstop for this
        // edge case. If already known blocked, still show blocked alert.
        if (isBlockedCountry()) { showBlockedCountryAlert(); return; }
        window.__tvcCheckoutPassed = true;
        try { clickedBtn.click(); } catch(_) {}
        setTimeout(function(){ window.__tvcCheckoutPassed = false; }, 500);
      });
  }, true);

  document.addEventListener("click", function(e){
    var btn = e.target.closest(".tvc-paypal-btn");
    if (!btn) return;
    if (window.__tvcMinPassed) return;
    if (isBlockedCountry()) { e.preventDefault(); e.stopPropagation(); return; }
    var isProductPage = window.location.pathname.indexOf("/products/") > -1;
    if (isProductPage && !window.__tvcDigitalProduct) {
      var el = document.querySelector(".price__regular .price-item--regular,.price .money,.price-item--sale");
      if (el) {
        var num = parseFloat(el.textContent.trim().replace(/[^\d.,]/g, "").replace(/,/g, ""));
        var fx = window.__saFxLastRate;
        if (num && fx && fx > 0 && (num / fx) < MIN_ORDER_INR) {
          e.preventDefault(); e.stopPropagation(); showMinOrderAlert();
        }
      }
      return;
    }
    e.preventDefault(); e.stopPropagation();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var anyPhysical = cart.items && cart.items.some(function(i){ return i.requires_shipping !== false; });
        if (anyPhysical && cart.total_price < (MIN_ORDER_INR * 100)) { showMinOrderAlert(); return; }
        window.__tvcMinPassed = true; btn.click();
        setTimeout(function(){ window.__tvcMinPassed = false; }, 500);
      })
      .catch(function(){
        window.__tvcMinPassed = true; btn.click();
        setTimeout(function(){ window.__tvcMinPassed = false; }, 500);
      });
  }, true);

  document.addEventListener("click", function(evt){
    var t = evt.target;
    if (!t) return;
    var submitBtn = t.id === "tvc-pp-submit" ? t : (t.closest && t.closest("#tvc-pp-submit"));
    if (!submitBtn) return;

    var name    = val("tvc-pp-name");
    var email   = val("tvc-pp-email");
    var phone   = val("tvc-pp-phone");
    var address = val("tvc-pp-address");
    var city    = val("tvc-pp-city");
    var state   = val("tvc-pp-state");
    var zip     = val("tvc-pp-zip");
    var country = val("tvc-pp-country");
    if (!name || !email || !phone || !address || !city || !country) return;

    var modal = document.querySelector(".tvc-pp-checkout-overlay.active") || document.querySelector(".tvc-pp-checkout-overlay");

    var origOpen = window.open;
    window.open = function(url, target, features){
      var newUrl = bestPaypalUrl(url, modal);
      if (window.__tvcDigitalProduct && !(modal && modal.dataset.tvcPaypalUrl)) newUrl = rewritePaypalUrlDigital(newUrl);
      return origOpen.call(window, newUrl, target, features);
    };
    setTimeout(function(){ window.open = origOpen; }, 3000);

    var sum = readSummary();
    try {
      fetch(SHEETS_URL, {
        method: "POST", mode: "no-cors", keepalive: true,
        headers: { "Content-Type": "text/plain;charset=utf-8" },
        body: JSON.stringify({
          name: name, email: email, phone: phone,
          address: address, city: city, state: state, zip: zip, country: country,
          product: sum.product, variant: sum.variant,
          price: sum.price, shipping: sum.shipping, total: sum.total,
          currency:   window.__saFxTargetCurrency || "INR",
          countryGeo: window.__saGeoCountry || "",
          pageUrl:    window.location.href,
          paypalLink: (modal && modal.dataset.tvcPaypalUrl) || "",
          paypalAmount: (modal && modal.dataset.tvcPaypalAmount) || "",
          isDigital:  !!window.__tvcDigitalProduct,
          submittedAt: new Date().toISOString()
        })
      }).catch(function(){});
    } catch (_) {}
  }, true);

  if (window.MutationObserver) {
    var modalRef = null;
    new MutationObserver(function(mutations){
      for (var i = 0; i < mutations.length; i++) {
        for (var j = 0; j < mutations[i].addedNodes.length; j++) {
          var node = mutations[i].addedNodes[j];
          if (node.nodeType !== 1) continue;
          if (node.classList) {
            if (node.classList.contains("tvc-pp-checkout-overlay")) {
              modalRef = node;
              (function(n){
                setTimeout(function(){ computeAndCachePaypalUrl(n); }, 10);
              })(node);
            }
            if (isNonIndia()) {
              // v12 direct + descendant scan
              // v16: Razorpay class removed — Razorpay is no longer hidden
              if (node.classList.contains("shopify-payment-button") ||
                  node.classList.contains("dynamic-checkout") ||
                  node.classList.contains("dynamic-checkout__content") ||
                  node.classList.contains("additional-checkout-buttons") ||
                  (node.hasAttribute && (node.hasAttribute("data-shopify-buttoncontainer") || node.hasAttribute("data-shopify")))) {
                node.style.display = "none";
              }
              if (node.querySelectorAll) {
                // v16: Razorpay selector removed from hide list
                var dyn = node.querySelectorAll('.shopify-payment-button,[data-shopify-buttoncontainer],[data-shopify^="dynamic-checkout"],.dynamic-checkout,.dynamic-checkout__content,.additional-checkout-buttons,shopify-accelerated-checkout,shopify-accelerated-checkout-cart');
                for (var d = 0; d < dyn.length; d++) dyn[d].style.display = "none";
              }
              // v13: run aggressive content-based scan (throttled implicitly
              // by MutationObserver — only fires when DOM actually changes)
              aggressiveHideAcceleratedCheckout();
              // v15: re-apply simplified flow (body class, banner, CSS)
              applySimplifiedFlow();
            }
            if (isBlockedCountry() && (
                node.classList.contains("tvc-paypal-wrap") ||
                node.classList.contains("tvc-shipping-notice") ||
                node.classList.contains("tvc-intl-banner")
            )) node.style.display = "none";
          }
        }
        if (modalRef && mutations[i].target) {
          var tgt = mutations[i].target;
          if (tgt === modalRef || (modalRef.contains && modalRef.contains(tgt))) {
            (function(m){ setTimeout(function(){ fixPostSubmitUrls(m); }, 40); })(modalRef);
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
})();

/* ═══ v16: PayPal Smart Buttons RE-ENABLED ═══
   Was previously disabled (v6). Re-enabled in v16 so the PayPal modal shows
   real Smart Buttons (create + capture real orders via Cloudflare Worker) in
   addition to the paypal.me manual fallback. tvc-paypal-api.js reads this
   config on load. */
(function(){
  if (window.__tvcPayPalConfig) return;
  window.__tvcPayPalConfig = { workerBase: 'https://late-grass-18d9.gauravbsharma.workers.dev', enabled: true, debug: false };
})();

/* ═══ Hide Vedic Remedy Finder on collection pages ═══ */
(function(){
  if (!/^\/collections(\/|$)/i.test(window.location.pathname)) return;
  try {
    var s = document.createElement('style');
    s.id = 'tvc-hide-finder-on-collections';
    s.textContent = '#tvc-find-remedy,#shopify-section-vedic_remedy_finder,.tvc-finder,.section-vedic-remedy-finder{display:none !important;visibility:hidden !important;height:0 !important;overflow:hidden !important;}';
    (document.head || document.documentElement).appendChild(s);
  } catch (_) {}
  function removeFinderElements(){
    var sels = ['#tvc-find-remedy','#shopify-section-vedic_remedy_finder','.tvc-finder','.section-vedic-remedy-finder'];
    for (var i = 0; i < sels.length; i++) {
      var nodes = document.querySelectorAll(sels[i]);
      for (var j = 0; j < nodes.length; j++) if (nodes[j].parentNode) nodes[j].parentNode.removeChild(nodes[j]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', removeFinderElements);
  else removeFinderElements();
  if (window.MutationObserver) {
    var obs = new MutationObserver(function(){ removeFinderElements(); });
    var start = function(){
      obs.observe(document.body || document.documentElement, { childList: true, subtree: true });
      setTimeout(function(){ obs.disconnect(); }, 8000);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
  }
})();